<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Expediente"
    }
  },
  data: () => ({
    expedienteTipoList: {},
    expedienteLocalList: {},
    clienteList: {},
    tarefaList: undefined,
    clienteId: undefined,
    tarefaId: undefined,
    loading: true,
    ready: false,
    revisandoComIa: false,
    corrigindoOrtografia: false,
    sucessoOrtografia: "",
    textoAntesCorrecao: "",
    showModalRevisaoIa: false,
    revisaoIa: null,
    erroRevisaoIa: "",
    gerandoResumoIa: false,
    showModalResumoCronologico: false,
    resumoCronologico: null,
    item: { tags: [], cobrarDeslocamento: false }
  }),
  computed: {
    dicasDescricao() {
      const descricao = (this.item.descricao || "").trim();
      if (descricao.length < 3) return [];

      const texto = descricao.toLowerCase();
      const dicas = [];
      if (descricao.length < 35 || descricao.split(/\s+/).length < 6) {
        dicas.push(
          "Detalhe o que foi feito e em qual sistema, módulo ou processo."
        );
      }
      if (
        !/\b(para|a fim de|com o objetivo|visando|solicitad[oa]|conforme|referente|relativo)\b/.test(
          texto
        )
      ) {
        dicas.push(
          "Explique qual solicitação ou necessidade motivou o trabalho."
        );
      }
      if (
        !/\b(conclu[ií]d[oa]|entregue|validado|corrigido|ajustado|publicado|resultado|pendente|aguardando|aprovado|testado|implementado|finalizado|em andamento)\b/.test(
          texto
        )
      ) {
        dicas.push(
          "Informe o resultado, a entrega realizada ou o próximo passo."
        );
      }
      return dicas.slice(0, 3);
    },
    nivelClarezaLabel() {
      if (!this.revisaoIa) return "";
      const labels = {
        claro: "Descrição clara",
        pode_melhorar: "Pode ficar mais clara",
        muito_vago: "Informações insuficientes"
      };
      return labels[this.revisaoIa.nivelClareza] || "Revisão concluída";
    },
    nivelClarezaVariant() {
      if (!this.revisaoIa) return "secondary";
      const variants = {
        claro: "success",
        pode_melhorar: "warning",
        muito_vago: "danger"
      };
      return variants[this.revisaoIa.nivelClareza] || "secondary";
    }
  },
  watch: {
    clienteId: function() {
      this.item.clienteId = this.clienteId;
      if (this.ready === true) {
        this.getTarefaList();
      }
    },
    tarefaId: function() {
      if (this.tarefaList) {
        let tarefa = this.tarefaList.filter(
          a => a.tarefaId == this.tarefaId
        )[0];
        if (tarefa) {
          this.item.tarefaId = tarefa.tarefaId;
          this.item.expedienteTipoId = tarefa.expedienteTipoId;
          this.item.expedienteLocalId = tarefa.expedienteLocalId;
          this.item.cobrarDeslocamento =
            tarefa.cobrarDeslocamento == null
              ? false
              : tarefa.cobrarDeslocamento;
          this.item.percentualConclusao = tarefa.percentualConclusao;
        }
      }
    }
  },
  created() {
    if (this.item.data === undefined || this.item.data === null) {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      this.item.data = today;
    }

    if (this.$route.query.tarefaId) {
      this.tarefaId = this.$route.query.tarefaId;
    }
    if (this.$route.query.clienteId) {
      this.clienteId = this.$route.query.clienteId;
    }
    this.ready = true;

    this.getExpedienteLocalList();
    this.getExpedienteTipoList();
    this.getClienteList();
  },
  methods: {
    beforeSave() {
      var tag = document.getElementById("input-tags").value;
      if (tag) {
        this.item.tags.push(tag);
      }
    },
    get(id) {
      api.get(`crud/${this.table}/${id}`).then(response => {
        this.item = response.data["data"];
        if (this.item.tarefaId) {
          this.tarefaId = this.item.tarefaId;
        }
        if (this.item.clienteId) {
          this.clienteId = this.item.clienteId;
        }
        this.loadedUpdate = true;
      });
    },
    getClienteList() {
      api.get(`api/Tarefa/Clientes`).then(response => {
        this.clienteList = response.data["data"];
        if (this.clienteId) {
          this.getTarefaList();
        }
      });
    },
    getTarefaList() {
      if (this.clienteId) {
        api
          .get(`api/Tarefa/Tarefas`, {
            params: {
              clienteId: this.clienteId,
              ativo: true
            }
          })
          .then(response => {
            this.tarefaList = response.data["data"];
            if (this.tarefaList) {
              if (
                this.tarefaList.length > 0 &&
                this.tarefaId === undefined &&
                this.table === "Expediente"
              ) {
                this.tarefaId = this.tarefaList[0].tarefaId;
              }
            }
          });
      }
    },
    getExpedienteLocalList() {
      api.get(`crud/Expediente/ExpedienteLocal`).then(response => {
        this.expedienteLocalList = response.data["data"];
        if (this.expedienteLocalList.length > 0) {
          if (
            this.item.expedienteLocalId === undefined &&
            this.table === "Expediente"
          ) {
            this.item.expedienteLocalId = this.expedienteLocalList[0].id;
          }
        }
      });
    },
    getExpedienteTipoList() {
      api.get(`crud/Expediente/ExpedienteTipos`).then(response => {
        this.expedienteTipoList = response.data["data"];
        if (this.expedienteTipoList.length > 0) {
          if (
            this.item.expedienteTipoId === undefined &&
            this.table === "Expediente"
          ) {
            this.item.expedienteTipoId = this.expedienteTipoList[0].id;
          }
        }
      });
    },
    findOption(list, id, key = "id") {
      if (!list || !Array.isArray(list)) return null;
      return list.find(item => item && item[key] == id) || null;
    },
    async corrigirOrtografia() {
      const texto = (this.item.descricao || "").trim();
      this.erroRevisaoIa = "";
      this.sucessoOrtografia = "";

      if (texto.length < 3) {
        this.erroRevisaoIa =
          "Escreva ao menos uma frase antes de solicitar a correção ortográfica.";
        return;
      }

      this.textoAntesCorrecao = this.item.descricao || "";
      this.corrigindoOrtografia = true;
      try {
        const response = await api.post("crud/Expediente/corrigir-ortografia", {
          texto
        });

        if (
          response &&
          response.data &&
          response.data.status.toLowerCase() === "success" &&
          response.data.data &&
          response.data.data.textoCorrigido
        ) {
          this.item.descricao = response.data.data.textoCorrigido;
          this.sucessoOrtografia = "✓ Ortografia e concordância corrigidas com sucesso!";
          setTimeout(() => {
            this.sucessoOrtografia = "";
          }, 8000);
        } else {
          this.erroRevisaoIa =
            (response && response.data && response.data.message) ||
            "Não foi possível corrigir a ortografia agora. Tente novamente.";
        }
      } catch (error) {
        this.erroRevisaoIa =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Não foi possível corrigir a ortografia agora. Tente novamente.";
      } finally {
        this.corrigindoOrtografia = false;
      }
    },
    desfazerCorrecao() {
      if (this.textoAntesCorrecao) {
        this.item.descricao = this.textoAntesCorrecao;
        this.textoAntesCorrecao = "";
        this.sucessoOrtografia = "";
      }
    },
    async revisarComIa() {
      const descricao = (this.item.descricao || "").trim();
      this.erroRevisaoIa = "";

      if (descricao.length < 3) {
        this.erroRevisaoIa =
          "Escreva ao menos uma frase antes de solicitar a revisão com IA.";
        return;
      }

      const cliente = this.findOption(this.clienteList, this.clienteId);
      const tarefa = this.findOption(
        this.tarefaList,
        this.tarefaId,
        "tarefaId"
      );
      const tipo = this.findOption(
        this.expedienteTipoList,
        this.item.expedienteTipoId
      );
      const local = this.findOption(
        this.expedienteLocalList,
        this.item.expedienteLocalId
      );

      this.revisandoComIa = true;
      try {
        const response = await api.post("crud/Expediente/revisar-com-ia", {
          descricao,
          tarefaId: this.tarefaId,
          clienteId: this.clienteId,
          expedienteId: this.item.id || undefined,
          cliente: cliente ? cliente.nome : undefined,
          tarefa: tarefa ? tarefa.descricao : undefined,
          tipo: tipo ? tipo.descricao : undefined,
          local: local ? local.denominacao : undefined
        });

        if (
          response &&
          response.data &&
          response.data.status.toLowerCase() === "success"
        ) {
          this.revisaoIa = response.data.data;
          this.showModalRevisaoIa = true;
        } else {
          this.erroRevisaoIa =
            (response && response.data && response.data.message) ||
            "Não foi possível revisar a descrição agora. Tente novamente.";
        }
      } catch (error) {
        this.erroRevisaoIa =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Não foi possível revisar a descrição agora. Tente novamente.";
      } finally {
        this.revisandoComIa = false;
      }
    },
    async obterResumoCronologicoIa() {
      if (!this.tarefaId && !this.clienteId) {
        this.erroRevisaoIa =
          "Selecione uma tarefa ou cliente para consultar o resumo da IA.";
        return;
      }

      const cliente = this.findOption(this.clienteList, this.clienteId);
      const tarefa = this.findOption(
        this.tarefaList,
        this.tarefaId,
        "tarefaId"
      );

      this.gerandoResumoIa = true;
      this.erroRevisaoIa = "";
      try {
        const response = await api.post(
          "crud/Expediente/resumo-cronologico-ia",
          {
            tarefaId: this.tarefaId,
            clienteId: this.clienteId,
            cliente: cliente ? cliente.nome : undefined,
            tarefa: tarefa ? tarefa.descricao : undefined
          }
        );

        if (
          response &&
          response.data &&
          response.data.status.toLowerCase() === "success"
        ) {
          this.resumoCronologico = response.data.data;
          this.showModalResumoCronologico = true;
        } else {
          this.erroRevisaoIa =
            (response && response.data && response.data.message) ||
            "Não foi possível gerar o resumo da IA agora. Tente novamente.";
        }
      } catch (error) {
        this.erroRevisaoIa =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Não foi possível gerar o resumo da IA agora. Tente novamente.";
      } finally {
        this.gerandoResumoIa = false;
      }
    },
    aplicarRevisaoIa() {
      if (this.revisaoIa && this.revisaoIa.descricaoReescrita) {
        this.item.descricao = this.revisaoIa.descricaoReescrita;
        this.erroRevisaoIa = "";
      }
      this.showModalRevisaoIa = false;
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <div class="row">
        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Cliente"
          label-for="clienteId"
        >
          <b-form-select
            id="clienteId"
            v-model="clienteId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in clienteList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-8"
          id="input-group-1"
          label="Tarefa"
          label-for="TarefaId"
        >
          <b-form-select
            id="TarefaId"
            v-model="tarefaId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in tarefaList"
              :key="option.tarefaId"
              :value="option.tarefaId"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Data"
          label-for="data"
        >
          <b-form-datepicker
            id="data"
            v-model="item.data"
            :disabled="!this.editForm"
            placeholder="Selecione uma data"
            :hide-header="true"
            locale="pt-BR"
            required
          ></b-form-datepicker>
        </b-form-group>

        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Hora inicial"
          label-for="horaInicio"
        >
          <b-form-input
            id="horaInicio"
            v-model="item.horaInicio"
            type="text"
            v-mask="'##:##'"
            placeholder="00:00"
            :disabled="!this.editForm"
            required
          />
        </b-form-group>

        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Hora final"
          label-for="horaFim"
        >
          <b-form-input
            id="horaFim"
            v-model="item.horaFim"
            type="text"
            v-mask="'##:##'"
            placeholder="00:00"
            :disabled="!this.editForm"
            required
          />
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Local do atendimento"
          label-for="expedienteLocalId"
        >
          <b-form-select
            id="expedienteLocalId"
            v-model="item.expedienteLocalId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in expedienteLocalList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.denominacao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Tipo do atendimento"
          label-for="expedienteTipoId"
        >
          <b-form-select
            id="expedienteTipoId"
            v-model="item.expedienteTipoId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in expedienteTipoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Cobrar deslocamento"
          label-for="cobrarDeslocamento"
        >
          <b-form-checkbox
            id="cobrarDeslocamento"
            v-model="item.cobrarDeslocamento"
            class="checkbox-lg"
            :disabled="!this.editForm"
          />
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="% Conclusão"
          label-for="percentualConclusao"
        >
          <b-form-input
            id="percentualConclusao"
            v-model="item.percentualConclusao"
            type="number"
            min="0"
            max="100"
            :disabled="!this.editForm"
          />
        </b-form-group>
      </div>

      <div class="expediente-description-header">
        <label for="descricao" class="mb-0">
          Descrição <span class="text-danger">*</span>
        </label>
        <div class="d-flex align-items-center">
          <b-button
            type="button"
            variant="outline-secondary"
            size="sm"
            class="mr-2"
            :disabled="corrigindoOrtografia"
            @click="corrigirOrtografia"
            title="Corrige erros de português, acentuação e concordância diretamente no texto"
          >
            <b-spinner v-if="corrigindoOrtografia" small class="mr-1" />
            <i v-else class="fa fa-pencil-square-o mr-1" aria-hidden="true"></i>
            {{ corrigindoOrtografia ? "Corrigindo..." : "Corrigir Ortografia" }}
          </b-button>
          <b-button
            type="button"
            variant="outline-info"
            size="sm"
            class="mr-2"
            :disabled="gerandoResumoIa || !tarefaId"
            @click="obterResumoCronologicoIa"
            title="Gera uma linha do tempo e resumo executivo dos últimos 20 expedientes da tarefa"
          >
            <b-spinner v-if="gerandoResumoIa" small class="mr-1" />
            <i v-else class="fa fa-bar-chart mr-1" aria-hidden="true"></i>
            {{ gerandoResumoIa ? "Gerando resumo..." : "Resumo da IA" }}
          </b-button>
          <b-button
            type="button"
            variant="outline-primary"
            size="sm"
            :disabled="revisandoComIa"
            @click="revisarComIa"
          >
            <b-spinner v-if="revisandoComIa" small class="mr-1" />
            <i v-else class="fa fa-magic mr-1" aria-hidden="true"></i>
            {{ revisandoComIa ? "Revisando..." : "Reescrever com IA" }}
          </b-button>
        </div>
      </div>
      <b-form-group id="input-group-descricao" label-for="descricao">
        <b-form-textarea
          id="descricao"
          v-model="item.descricao"
          placeholder="Ex.: Corrigido o cálculo de impostos no módulo fiscal para atender à solicitação do cliente; cenário testado e validado."
          type="text"
          :disabled="!this.editForm"
          rows="6"
          maxlength="5000"
          aria-describedby="descricao-ajuda"
          @input="erroRevisaoIa = ''; sucessoOrtografia = ''"
          required
        />
        <small id="descricao-ajuda" class="form-text text-muted">
          Uma boa descrição explica o que foi feito, o motivo e o resultado ou
          próximo passo.
        </small>
      </b-form-group>

      <!-- Feedback e Dicas de Estrutura da Descrição -->
      <b-alert
        v-if="this.editForm && dicasDescricao.length"
        show
        variant="warning"
        class="expediente-writing-tips mt-2"
      >
        <div class="d-flex align-items-center mb-1">
          <strong class="text-dark"><i class="fa fa-lightbulb-o mr-1 text-warning"></i> Sua descrição pode ficar mais clara:</strong>
        </div>
        <ul class="mb-0 pl-3">
          <li v-for="(dica, idx) in dicasDescricao" :key="idx">{{ dica }}</li>
        </ul>
      </b-alert>

      <b-alert
        v-if="sucessoOrtografia"
        show
        variant="success"
        dismissible
        @dismissed="sucessoOrtografia = ''"
        class="d-flex justify-content-between align-items-center mb-2"
      >
        <span>{{ sucessoOrtografia }}</span>
        <b-button
          v-if="textoAntesCorrecao"
          variant="outline-dark"
          size="sm"
          class="ml-2 py-0 px-2 font-weight-bold"
          @click="desfazerCorrecao"
          title="Restaura o texto original digitado antes da correção"
        >
          <i class="fa fa-undo mr-1"></i> Desfazer
        </b-button>
      </b-alert>

      <b-alert
        v-if="erroRevisaoIa"
        show
        variant="danger"
        dismissible
        @dismissed="erroRevisaoIa = ''"
      >
        {{ erroRevisaoIa }}
      </b-alert>

      <b-form-group id="input-group-1" label="Tags" label-for="tags">
        <b-form-tags
          id="tags"
          input-id="input-tags"
          v-model="item.tags"
          type="text"
          separator=" "
          placeholder="Adicionar tag..."
          :disabled="!this.editForm"
          remove-on-delete
        />
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group
        id="button-group"
        class="mt-4"
        v-show="!this.editForm"
        v-if="this.loadedUpdate"
      >
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button
          v-if="this.item.expedienteProprio"
          variant="primary"
          class="btn ml-2"
          v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="secondary" class="btn ml-2" v-on:click="callCopy()"
          >Copiar</b-button
        >
        <b-button
          v-if="this.item"
          variant="danger"
          class="btn ml-2"
          v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>

    <!-- Modal de Revisão da Descrição com IA -->
    <b-modal
      v-model="showModalRevisaoIa"
      title="Revisão da descrição com IA"
      size="lg"
      centered
      scrollable
      hide-footer
    >
      <template v-if="revisaoIa">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <span class="text-muted">Confira a sugestão antes de aplicá-la.</span>
          <b-badge :variant="nivelClarezaVariant" pill>
            {{ nivelClarezaLabel }}
          </b-badge>
        </div>

        <!-- Seção de Contexto Histórico Considerado -->
        <section
          v-if="
            revisaoIa.historicoConsiderado &&
              revisaoIa.historicoConsiderado.length
          "
          class="expediente-ai-history mb-3"
        >
          <div class="d-flex align-items-center mb-2 font-weight-bold text-secondary">
            <i class="fa fa-history text-primary mr-2"></i> Contexto dos últimos {{ revisaoIa.historicoConsiderado.length }} lançamentos considerados:
          </div>
          <div class="list-group list-group-flush border rounded bg-white">
            <div
              v-for="(hist, idx) in revisaoIa.historicoConsiderado"
              :key="idx"
              class="list-group-item list-group-item-light py-2 px-3 small text-dark"
            >
              <i class="fa fa-angle-right text-primary mr-2"></i> {{ hist }}
            </div>
          </div>
        </section>

        <section
          v-if="
            revisaoIa.informacoesFaltantes &&
              revisaoIa.informacoesFaltantes.length
          "
          class="expediente-ai-missing mb-3"
        >
          <strong>Antes de cobrar, vale complementar:</strong>
          <ul class="mb-0 mt-2 pl-3">
            <li
              v-for="informacao in revisaoIa.informacoesFaltantes"
              :key="informacao"
            >
              {{ informacao }}
            </li>
          </ul>
        </section>

        <section
          v-if="revisaoIa.pontosMelhoria && revisaoIa.pontosMelhoria.length"
          class="mb-3"
        >
          <h6>Principais pontos para melhorar</h6>
          <div
            v-for="ponto in revisaoIa.pontosMelhoria"
            :key="ponto.titulo"
            class="expediente-ai-point"
          >
            <span aria-hidden="true">✓</span>
            <div>
              <strong>{{ ponto.titulo }}</strong>
              <div class="text-muted">{{ ponto.detalhe }}</div>
            </div>
          </div>
        </section>

        <section
          v-if="revisaoIa.resumoAlteracoes && revisaoIa.resumoAlteracoes.length"
          class="mb-3"
        >
          <h6>Resumo das alterações</h6>
          <ul class="mb-0 pl-3">
            <li
              v-for="(alteracao, idx) in revisaoIa.resumoAlteracoes"
              :key="idx"
            >
              {{ alteracao }}
            </li>
          </ul>
        </section>

        <div class="row">
          <div class="col-md-6 mb-3 mb-md-0">
            <h6 class="text-muted">Texto original</h6>
            <div class="expediente-ai-copy expediente-ai-copy--original">
              {{ item.descricao }}
            </div>
          </div>
          <div class="col-md-6">
            <h6 class="text-primary">Sugestão da IA</h6>
            <div class="expediente-ai-copy expediente-ai-copy--suggestion">
              {{ revisaoIa.descricaoReescrita }}
            </div>
          </div>
        </div>

        <div class="expediente-ai-disclaimer mt-3">
          A IA pode cometer erros. Confirme se a sugestão representa exatamente
          o trabalho realizado.
        </div>

        <div class="d-flex justify-content-end mt-4">
          <b-button variant="light" @click="showModalRevisaoIa = false">
            Manter meu texto
          </b-button>
          <b-button variant="primary" class="ml-2" @click="aplicarRevisaoIa">
            Usar esta versão
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Modal de Resumo Cronológico da IA (Top 20) -->
    <b-modal
      v-model="showModalResumoCronologico"
      :title="resumoCronologico ? resumoCronologico.titulo : 'Resumo da IA'"
      size="xl"
      centered
      scrollable
      hide-footer
    >
      <template v-if="resumoCronologico">
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 pb-2 border-bottom">
          <div class="text-muted small">
            <span v-if="resumoCronologico.periodo" class="mr-3">
              📅 <strong>Período:</strong> {{ resumoCronologico.periodo }}
            </span>
            <span>
              📋 <strong>Expedientes analisados:</strong> {{ resumoCronologico.totalExpedientesAnalisados }}
            </span>
          </div>
          <b-badge variant="info" pill class="px-3 py-2">
            Síntese Executiva de Avanços
          </b-badge>
        </div>

        <div class="card mb-4 bg-light border-0 shadow-sm">
          <div class="card-body">
            <h6 class="text-primary font-weight-bold mb-2">
              <i class="fa fa-file-text-o mr-1"></i> Resumo Executivo da Evolução
            </h6>
            <p class="mb-0 text-dark" style="white-space: pre-line; line-height: 1.6;">
              {{ resumoCronologico.resumoExecutivo }}
            </p>
          </div>
        </div>

        <div v-if="resumoCronologico.fasesOuEtapas && resumoCronologico.fasesOuEtapas.length" class="mb-4">
          <h6 class="font-weight-bold mb-3">
            <i class="fa fa-tasks mr-1 text-primary"></i> Linha do Tempo e Etapas Desenvolvidas
          </h6>
          <div class="timeline-container">
            <div
              v-for="(fase, idx) in resumoCronologico.fasesOuEtapas"
              :key="idx"
              class="timeline-item mb-3"
            >
              <div class="timeline-badge bg-primary text-white font-weight-bold">
                {{ idx + 1 }}
              </div>
              <div class="timeline-content p-3 border rounded shadow-sm bg-white">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <strong class="text-dark">{{ fase.fase }}</strong>
                  <b-badge v-if="fase.periodo" variant="light" class="border text-secondary">
                    {{ fase.periodo }}
                  </b-badge>
                </div>
                <ul class="mb-0 pl-3 small text-muted">
                  <li v-for="(ativ, aIdx) in fase.atividadesPrincipais" :key="aIdx">
                    {{ ativ }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="card h-100 border-success shadow-sm">
              <div class="card-header bg-success text-white py-2 font-weight-bold">
                <i class="fa fa-check-circle mr-1"></i> Principais Entregas Consolidadas
              </div>
              <div class="card-body py-2">
                <ul class="mb-0 pl-3 small">
                  <li v-for="(entrega, idx) in resumoCronologico.principaisEntregas" :key="idx" class="mb-1">
                    {{ entrega }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card h-100 border-info shadow-sm">
              <div class="card-header bg-info text-white py-2 font-weight-bold">
                <i class="fa fa-arrow-circle-right mr-1"></i> Próximos Passos e Pendências
              </div>
              <div class="card-body py-2">
                <ul class="mb-0 pl-3 small">
                  <li v-for="(passo, idx) in resumoCronologico.proximosPassosOuPendencias" :key="idx" class="mb-1">
                    {{ passo }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3 pt-2 border-top">
          <b-button variant="primary" @click="showModalResumoCronologico = false">
            Fechar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
.expediente-client-note {
  display: flex;
  align-items: flex-start;
  border-left: 4px solid #17a2b8;
}

.expediente-client-note__icon {
  display: inline-flex;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 10px;
  color: #fff;
  font-weight: 700;
  background: #17a2b8;
  border-radius: 50%;
}

.expediente-description-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.expediente-writing-tips {
  border-left: 4px solid #f7b84b;
}

.expediente-ai-history {
  background: #f8f9fa;
  padding: 12px 14px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.expediente-ai-missing {
  padding: 14px 16px;
  color: #664d03;
  background: #fff3cd;
  border: 1px solid #ffecb5;
  border-radius: 6px;
}

.expediente-ai-point {
  display: flex;
  gap: 10px;
  padding: 9px 0;
  border-bottom: 1px solid #edf0f2;
}

.expediente-ai-point > span {
  color: #389a78;
  font-weight: 700;
}

.expediente-ai-copy {
  min-height: 130px;
  padding: 14px;
  line-height: 1.55;
  white-space: pre-wrap;
  background: #f6f7f9;
  border: 1px solid #e5e8eb;
  border-radius: 6px;
}

.expediente-ai-copy--suggestion {
  background: #f0faf6;
  border-color: #a9dfca;
}

.expediente-ai-disclaimer {
  padding: 10px 12px;
  color: #6c757d;
  font-size: 0.85rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.timeline-container {
  position: relative;
  padding-left: 20px;
  border-left: 2px solid #dee2e6;
  margin-left: 14px;
}

.timeline-item {
  position: relative;
}

.timeline-badge {
  position: absolute;
  left: -32px;
  top: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
}

@media (max-width: 575.98px) {
  .expediente-description-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .expediente-description-header .btn {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
